import './App.css';
import './Styles/style.module.scss';
import { React, useRef, useEffect, createElement } from "react";
import useState from 'react-usestateref';
import GEST_API from './Api/GESTApi';
import store from './store'
import ProjectPage from './Components/Pages/Project';
import {CONTENT} from './Store/Actions'
import Reachability from './Components/Shared/Reachability';
import Conflict from './Components/Shared/Conflict';
import MobileOptimisation from './Components/Shared/MobileOptimisation'
import GAINTemplate from './Components/Pages/GAINTemplate';
import WelcomeScreen from './Components/Pages/Welcome';
import SchemaData from './Data/schema';


// MUI Imports
import Box from '@mui/material/Box';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

function App() {

  const [project, setProject, projectRef] = useState(null);
  const [projectId, setProjectId] = useState(null);
  const [schema, setSchema] = useState(null);
  const [hasUpdates, setHasUpdates, hasUpdatesRef] = useState(false);
  const [isInConflict, setIsInConflict, isInConflictRef] = useState(false);
  const [connectionIssue, setConnectionIssue] = useState(false);
  
  let updateCallStackCount = useRef(0)
  let saveTimeout = useRef(null);

  function onProjectEntryUpdate(key, value){

    GEST_API.STOP_UPDATE_TRACKER();
    GEST_API.PROJECT_SAVING = true

    updateCallStackCount.current++

    if(saveTimeout.current){
      clearTimeout(saveTimeout.current)
      updateCallStackCount.current--
      saveTimeout.current = null
    }

    saveTimeout.current = setTimeout(() => {
      let projectClone = JSON.parse(JSON.stringify(projectRef.current));

      projectClone.entries[key] = value;
      projectClone.projectId = projectId;
  
      GEST_API.SAVE_PROJECT(projectClone).then((data)=>{

          //Keep the timestamp up to date to ensure no false conflicts
          let projectWithTimestampUpdate = {project:JSON.parse(JSON.stringify(projectRef.current))};
          projectWithTimestampUpdate.project.lastUpdateTimestamp = data.payload.project.lastUpdateTimestamp
          setProject(projectWithTimestampUpdate.project)

          //We don't want to update the content if there is another save request invoked right behind this one
          //If we don't do this it will look glitchy to the end user and will flag false conflicts

          if(updateCallStackCount.current < 2){
            if(data.response.inConflict){
              setIsInConflict(true);
            }else{
              setHasUpdates(false)
              store.dispatch({ type: CONTENT.PROJECT_CONTENT_RECIVED, payload: projectWithTimestampUpdate })
            }
          }else{

            //Avoid conflicts with subsequent save calls
            
          }
          
          updateCallStackCount.current--

      });

      setProject(projectClone)

      saveTimeout.current = null

    }, 1000);

    setHasUpdates(true)
    hasUpdatesRef.current = true

  }

  function onConflictResolution(action, savedTimestamp){
    switch (action) {
      case "pushed":

          let projectWithTimestampUpdate = {project:JSON.parse(JSON.stringify(projectRef.current))};
          projectWithTimestampUpdate.project.lastUpdateTimestamp = savedTimestamp
          store.dispatch({ type: CONTENT.PROJECT_CONTENT_RECIVED, payload: projectWithTimestampUpdate.project })

          setHasUpdates(false);
          setIsInConflict(false);

        break;
      default:

        GEST_API.START_UPDATE_CHECKER()
        setHasUpdates(false);
        setIsInConflict(false);

        setTimeout(() => {
          store.dispatch({ type: CONTENT.PROJECT_CONTENT_RECIVED, payload: store.getState() })
        }, 50);

        break;
    }

  }

  useEffect(() => {

    let pathParts = window.location.pathname.split('/')
    let projectIdPathIndex = pathParts.indexOf("project") + 1
    let projectId = pathParts[projectIdPathIndex]
    setProjectId(projectId)

    store.subscribe(() => {

      if(!hasUpdatesRef.current && !isInConflictRef.current){
        setProject(store.getState().project)
      }

      setConnectionIssue(store.getState().connectionIssue)

    })

    setSchema(SchemaData)

    //Important to define the project ID
    store.dispatch({ type: CONTENT.PROJECT_ID_DEFINED, payload: projectId })
    GEST_API.START_UPDATE_CHECKER()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  useEffect(() => {

    GEST_API.IN_CONFLICT = isInConflict;
    // eslint-disable-next-line react-hooks/exhaustive-deps

  },[isInConflict])

  useEffect(() => {

      if(hasUpdates && !isInConflictRef.current){
        GEST_API.SAVE_PROJECT(projectRef.current).then((savedPayload)=>{
          setProject(savedPayload)
        });
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
  },[connectionIssue])

  useEffect(() => {

    if(projectId)
      GEST_API.GET_PROJECT(projectId, project.lastUpdateTimestamp);
      // eslint-disable-next-line react-hooks/exhaustive-deps
  },[projectId])

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
      <Reachability connectionIssue={connectionIssue}/>
      <Conflict conflictState={isInConflict} onResolution={onConflictResolution} project={project}/>
      <MobileOptimisation />
      <Router>
        <GAINTemplate schema={schema} project={project}>
          <Box className='content_container'
            sx={{
              border: 1,
              borderColor:"#707070"
            }}
          >
              <Routes>
                {(
                  store.getState().projectPages.map((page, index)=>{

                    // let page = store.getState().pages[pageKey];
                    let pageContentComponent = createElement(page.component, {
                      onUpdate:
                        (key, value) => {
                          onProjectEntryUpdate(key,value)
                        }
                      ,
                      project:project,
                      schema:schema,
                      csvDownloadUrl:store.getState().appExportBaseURL+'?projectId='+projectId
                    });

                    return (
                      
                      <Route key={index} path={`${process.env.PUBLIC_URL}/project/:projectId/${page.slug}`} element={

                        <ProjectPage 
                          pageMeta={page}
                          pageMetas={store.getState().pages}
                          projectData={project}
                          schema={schema}>
                            {pageContentComponent}

                        </ProjectPage>
                      }/>

                    )
                  })
                )}
                <Route path={`${process.env.PUBLIC_URL}/project/:projectId/${store.getState().pages.welcome.slug}`} element={
                    <WelcomeScreen schema={schema} project={project}/>
                }/>
              </Routes>
          </Box>
        </GAINTemplate>
      </Router>
      </ThemeProvider>
      
    </div>
  );
}
export default App;